import { CommonModule } from '@angular/common';
import { Component, effect, inject, Injectable } from '@angular/core';
import { DocumentTypeEnum, ExportToPdfService } from '../../../../shared/services/export-to-pdf.service';
import { PrintDocumentService } from '../../../../print-documents/print-document.service';
import { IReservationReport } from '../../../../utils/interfaces/reservation-report';
import { IReportFilter } from '../../../../utils/interfaces/report-filter';
import { ReportFilterService } from '../../../../shared/services/report-filter.service';
import { LoadingService } from '../../../../shared/services/loading.service';
import { ReservationReportService } from '../../../../shared/services/reporting-services/reservation-report.service';
import { Subject, takeUntil, defer, finalize } from 'rxjs';
import { PrintFilterDataComponent } from '../../../../shared/components/print-filter-data/print-filter-data.component';
import { ReservationCardComponent } from './reservation-card/reservation-card.component';

@Component({
  selector: 'app-reservation',
  standalone: true,
  imports: [CommonModule, PrintFilterDataComponent, ReservationCardComponent],
  templateUrl: './reservation.component.html',
  styleUrl: './reservation.component.scss',
  providers: [ReservationReportService],
})

export class ReservationComponent {

  print = false;
  private readonly unsubscribe$ = new Subject();
  data: IReservationReport[] = [];
  filter: IReportFilter | null = null;

  constructor(
    private readonly reportFilterService: ReportFilterService,
    private readonly reservationReportService: ReservationReportService,
    private readonly exportToPdfService: ExportToPdfService,
    private readonly printDocumentService: PrintDocumentService,
    private readonly loadingService: LoadingService,
  ) {
    effect(
      () => {
        this.printDocument(exportToPdfService.getDocumentType());
      },
      {
        allowSignalWrites: true,
      }
    );
    effect(
      () => {
        this.filter = reportFilterService.getFilter();
        this.getReportData();
      },
      {
        allowSignalWrites: true,
      }
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
  getReportData(): void {
    if (!this.filter) return;

    defer(() => {
      this.loadingService.showLoading();
      return this.reservationReportService.getReservationReport(this.filter!);
    })
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => this.loadingService.closeLoading())
      )
      .subscribe((res) => {
        this.data = res.data;
      });
  }

  printDocument(document: DocumentTypeEnum | null): void {
    if (!document || !this.data) {
      this.exportToPdfService.generatePDF(null);
      return;
    }

    this.printDocumentService.printDocument(DocumentTypeEnum.reservation, {
      data: this.data,
      filter: this.filter,
    });

    this.exportToPdfService.generatePDF(null);
  }

  exportToExcel() {
    if (!this.filter) return;

    setTimeout(() => {
      this.loadingService.showLoading();
    }, 0);

    this.reservationReportService
      .getReservationReportXlsx(this.filter)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'relatorio-reservas.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        setTimeout(() => {
          this.loadingService.closeLoading();
        }, 750);
      });
  }


}
